import { render, staticRenderFns } from "./DOTSPatientEdit.vue?vue&type=template&id=4e7b9f64&scoped=true"
import script from "./DOTSPatientEdit.vue?vue&type=script&lang=js"
export * from "./DOTSPatientEdit.vue?vue&type=script&lang=js"
import style0 from "./DOTSPatientEdit.vue?vue&type=style&index=0&id=4e7b9f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b9f64",
  null
  
)

export default component.exports